function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.75234 17.7471C3.75273 17.9928 3.82539 18.2334 3.96172 18.4381L4.6293 19.4416C4.74334 19.6132 4.89802 19.7539 5.07957 19.8512C5.26113 19.9485 5.46393 19.9994 5.66992 19.9994H8.08047C8.28646 19.9994 8.48926 19.9485 8.67082 19.8512C8.85237 19.7539 9.00705 19.6132 9.12109 19.4416L9.78867 18.4381C9.92494 18.2334 9.99777 17.993 9.99805 17.7471L9.99961 16.2491H3.75039L3.75234 17.7471ZM0 6.87406C0 8.60726 0.642578 10.1885 1.70156 11.3967C2.34688 12.133 3.35625 13.6713 3.74102 14.969C3.74258 14.9791 3.74375 14.9893 3.74531 14.9994H10.0047C10.0062 14.9893 10.0074 14.9795 10.009 14.969C10.3938 13.6713 11.4031 12.133 12.0484 11.3967C13.1074 10.1885 13.75 8.60726 13.75 6.87406C13.75 3.06976 10.6605 -0.012662 6.85352 -0.000943259C2.86875 0.0111661 0 3.24007 0 6.87406ZM6.875 3.74906C5.15195 3.74906 3.75 5.15101 3.75 6.87406C3.75 7.21937 3.47031 7.49906 3.125 7.49906C2.77969 7.49906 2.5 7.21937 2.5 6.87406C2.5 4.46156 4.4625 2.49906 6.875 2.49906C7.22031 2.49906 7.5 2.77874 7.5 3.12406C7.5 3.46937 7.22031 3.74906 6.875 3.74906Z",
  fill: "black"
});

var SvgIdeeaView = function SvgIdeeaView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIdeeaView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ideea_view.996d7e46.svg";
export { ForwardRef as ReactComponent };